import { DisabledPrompt, useBCMSModal, useRoute, useModel } from "@bcm-dev/bcms-vite";
import CustomModal, { CustomModalContent, ModalPrimaryButton, ModalSecondaryButton } from "components/custom-ui/CustomModal";
import CustomSelect, { CustomSelectItem } from "components/custom-ui/CustomSelect";
import { FormContainer, FormRowView } from "components/shared";
import { FormButtonRow } from "components/shared/containers/FormContainer";
import React from "react";

import "./styles.css";
import "./mobile.css";


/**
 * @function OneTimeACHModal
 * @return {React.Component}
 * @exported true
 * @description The main component for the OneTimeACHModal
 */
export default function OneTimeACHModal(props) {
    const onChangeDataProp = props.data.onChangeDataProp ?? (() => {});
    const onChangeUIProp = props.data.onChangeUIProp ?? (() => {});
    const { branding } = useModel();
    const { options } = branding;
    const hasNonConsumerCredit = options.nonconsumer_credit_abi22 === "true";
    const hasACHCollection = options.ach_collection_abi22 === "true";
    
    // "oneTimeACHPayment" is an object that needs the 
    // properties used in this page, like "transactionType".
    // This modal was initially build out for a specific 
    // page but it's now being repurposed in other pages.
    const oneTimeACHPayment = props.data.oneTimeACHPayment ?? {};
    const validValues = oneTimeACHPayment.transactionType && oneTimeACHPayment.secCode;
    const onCloseClickNavigateTo = props.data.onCloseClickNavigateTo ?? '/achActivity';
    const data = props.data.data ?? {};
    const ui = props.data.ui ?? {};

    const navigate = useRoute();
    const { close } = useBCMSModal();
    let secCodes = [
        { id: "0", value: "PPD Credit - Consumer Credit" },
        { id: "1", value: "CCD Credit - Non-Consumer Credit" }
    ];

    let transactionTypes = [
        { id: "0", value: "Payment" },
        { id: "1", value: "Collection", disabled: true }
    ];

    if(!hasNonConsumerCredit) {
        secCodes = secCodes.filter(code => {
            return !code.value.includes("CCD Credit - Non-Consumer Credit");
        });
    }

    secCodes = props.data.secCodes ?? secCodes;

    const secCodeItems = secCodes.reduce((acc, item) => {
        if(item.disabled) {
            acc.push(
                <DisabledPrompt key={ item.id }>
                    <CustomSelectItem key={ item.id } dataPoint={ `One_Time_Modal_Sec_Option_${ item.id }` }>{ item.value }</CustomSelectItem>
                </DisabledPrompt>
            );
        } else {
            acc.push(<CustomSelectItem key={ item.id } dataPoint={ `One_Time_Modal_Sec_Code_Option_${ item.id }` }>{ item.value }</CustomSelectItem>);
        }
        return acc;
    }, []);

    const transactionTypeItems = transactionTypes.reduce((acc, item) => {
        if(item.disabled) {
            if(hasACHCollection) {
                acc.push(
                    <DisabledPrompt key={ item.id }>
                        <CustomSelectItem key={ item.id } id={ item.id } value="collection" dataPoint={ `One_Time_Modal_Option_Collection` }>Collection</CustomSelectItem>
                    </DisabledPrompt>
                );
            }
        } else {
            acc.push(<CustomSelectItem key={ item.id } id={ item.id } value="payment" dataPoint={ `One_Time_Modal_Option_Payment` }>Payment</CustomSelectItem>);
        }
        return acc;
    }, []);

    const onNextClick = () => {
        onChangeUIProp("showSecCode")(true);
        onChangeUIProp("showOneTimeACHModal")(false);
        close("OneTimeACHModal");  
    };
    
    const onCloseClick = () => navigate(onCloseClickNavigateTo);

    return (
        <CustomModal id="OneTimeACHModal" className="one-time-ach-modal">
            <CustomModalContent>
                <FormContainer>
                    <FormRowView text="* Transaction Type">
                        <CustomSelect value={ oneTimeACHPayment.transactionType } active={ ui.transactionTypeSelectIsActive.isActive } dataPoint={ `One_Time_Modal_Payment_Select` } onChange={ onChangeDataProp("transactionType") }>
                            { transactionTypeItems }
                        </CustomSelect>
                    </FormRowView>
                   { oneTimeACHPayment.transactionType &&   
                    <FormRowView text="* Sec Code">
                     <CustomSelect value={ oneTimeACHPayment.secCode } active={ ui.secCodeSelectIsActive.isActive } 
                     dataPoint={ `One_Time_Modal_Payment_Sec_Code_Select` } onChange={ onChangeDataProp("secCode") }>
                        { secCodeItems }
                    </CustomSelect>
                    
                    </FormRowView>  
                    }
                    <FormButtonRow >
                        { validValues && <ModalPrimaryButton text="Next" dataPoint={ `One_Time_Modal_Payment_Next_Button` } onClick={ onNextClick }/> } 
                        { !validValues &&
                        <div>
                            <DisabledPrompt>
                                <ModalPrimaryButton text="Next" dataPoint={ `One_Time_Modal_Payment_Next_Button` } />
                            </DisabledPrompt>
                        </div>
                        }                               
                        <ModalSecondaryButton text="Close" dataPoint={ `One_Time_Modal_Payment_Close_Button` } onClick={onCloseClick} />                       
                    </FormButtonRow>
                </FormContainer>
            </CustomModalContent>
        </CustomModal>
    )
}
